import { frontendURL } from '../../../helper/URLHelper';
import { INTERNAL_CHAT_VIEW_PERMISSIONS } from 'dashboard/constants/permissions';

const InternalChatView = () => import('./pages/InternalChatView.vue');

// Chat interno (#1748). `meta.permissions` espelha InternalChat::Access.permitted?: o
// administrador passa sempre; os demais, com `internal_chat_view` (que o atendente comum tem
// pelo piso). A flag da conta é conferida na própria tela — o roteador daqui não olha flag.
//
// O grupo (#1749) tem rota própria, com a mesma tela e a mesma permissão: estar no grupo é o que
// basta para lê-lo. Quem decide se a pessoa é membro é o servidor (404 para quem não é).
export const routes = [
  {
    path: frontendURL('accounts/:accountId/internal-chat/groups/:groupId'),
    name: 'internal_chat_group',
    meta: {
      permissions: ['administrator', INTERNAL_CHAT_VIEW_PERMISSIONS],
    },
    component: InternalChatView,
  },
  {
    path: frontendURL('accounts/:accountId/internal-chat/:userId?'),
    name: 'internal_chat',
    meta: {
      permissions: ['administrator', INTERNAL_CHAT_VIEW_PERMISSIONS],
    },
    component: InternalChatView,
  },
];
